import React, {FC} from 'react';
import {IconsCache, SpriteContextProvider, initOnClient} from 'react-lazy-svg';
import {ExpensiveMediaProvider} from '../hooks/useExpensiveMedia';
import {ViewportProvider} from './ViewportProvider';
import {IconsProvider} from './atoms/Icon/IconsProvider';

interface Props {
  loadIconSVG: (key: string) => Promise<string | undefined>;
  knownIcons?: IconsCache;
  children?: React.ReactNode;
}

interface UIProvider extends FC<Props> {
  initClient: (cache: IconsCache) => void;
}

export const UIProvider: UIProvider = ({children, loadIconSVG, knownIcons}) => {
  return (
    <ViewportProvider experimentalSchedulerEnabled>
      <SpriteContextProvider loadSVG={loadIconSVG} knownIcons={knownIcons}>
        <IconsProvider>
          <ExpensiveMediaProvider>{children}</ExpensiveMediaProvider>
        </IconsProvider>
      </SpriteContextProvider>
    </ViewportProvider>
  );
};

UIProvider.initClient = (cache: IconsCache) => {
  initOnClient(cache);
};
